module.exports = __webpack_public_path__ + "static/media/1.a4d4f1c8.jpg";